module.exports = __webpack_public_path__ + "img/icon-minus.67f56149.svg";